import { gql } from 'apollo-angular';

export const POST_RFP_RESPONSES_OID_DOWNLOAD_URL = gql`
  query OfferItemDetailDownload($rfpId: Long!) {
    offerItemDetailDownload(rfpId: $rfpId) {
      url
    }
  }
`;
